import { useState, useEffect, useCallback } from 'react';

const KEY = 'bm_entry_mode';

let _mode = localStorage.getItem(KEY) || 'form';
const _listeners = new Set();

export function useEntryMode() {
  const [mode, setMode] = useState(_mode);

  useEffect(() => {
    const handler = m => setMode(m);
    _listeners.add(handler);
    return () => _listeners.delete(handler);
  }, []);

  const toggle = useCallback(() => {
    const next = _mode === 'form' ? 'story' : 'form';
    _mode = next;
    localStorage.setItem(KEY, next);
    _listeners.forEach(fn => fn(next));
  }, []);

  return { mode, toggle, isStory: mode === 'story', isForm: mode === 'form' };
}
